var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-layout',{staticStyle:{"margin":"18px"},attrs:{"row":""}},[_c('support-dialog',{ref:"TableData",attrs:{"dialog":_vm.updateoption},on:{"close":_vm.CloseDialog,"Update":_vm.CallUpdate}}),_c('support-table',{ref:"UpdateTable",on:{"UPDATE":_vm.update}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }